import {
  CancelDialogActions,
  ImageCancelDialogLayout,
  CancelModal,
  CancelDialogMessageLayout,
} from '@Components/shared/dialogs/CancelDialog';
import { useCreateProvider } from '@Modal/hooks/providers/useCreateProvider';

export const CreateProviderCancelModalDialog: React.FC = () => {
  const { handleCancelTakeMeBack, showCancelProviderForm } = useCreateProvider();

  return (
    <>
      {showCancelProviderForm && (
        <CancelModal open={showCancelProviderForm}>
          <ImageCancelDialogLayout
            title="Cancel vehicle changes?"
            actions={
              <CancelDialogActions
                onReject={() => handleCancelTakeMeBack('back')}
                onConfirm={() => handleCancelTakeMeBack('')}
              />
            }
          >
            <CancelDialogMessageLayout>
              You are about to delete all the changes you have made in provider settings
            </CancelDialogMessageLayout>
          </ImageCancelDialogLayout>
        </CancelModal>
      )}
    </>
  );
};
